// react
import React, {useState, useEffect} from "react";

// third-party
import classNames from "classnames";
import PropTypes from "prop-types";

// application
import { ArrowRoundedLeft7x11Svg, ArrowRoundedRight7x11Svg } from "../../svg";

function BlockHeaderFlashSale(props) {
	const { title, groups, onPrev, onNext, onGroupClick } = props;
	let { arrows } = props;

	const calculateNextFlashSale = () => {
			const now = new Date(); // Waktu saat ini
			const currentHours = now.getHours(); // Jam saat ini
			const nextFlashSaleHour = Math.ceil((currentHours + 1) / 6) * 6; // Membulatkan ke kelipatan 6 jam berikutnya
			const nextFlashSaleDate = new Date(now);
		
			if (nextFlashSaleHour >= 24) {
				// Jika melewati tengah malam, reset ke hari berikutnya
				nextFlashSaleDate.setDate(now.getDate() + 1);
				nextFlashSaleDate.setHours(nextFlashSaleHour - 24);
			} else {
				nextFlashSaleDate.setHours(nextFlashSaleHour);
			}
		
			nextFlashSaleDate.setMinutes(0); // Reset menit ke 0
			nextFlashSaleDate.setSeconds(0); // Reset detik ke 0
		
			return nextFlashSaleDate;
		};
	
		const useFlashSaleTimer = () => {
			const [timeLeft, setTimeLeft] = useState(null);
		
			useEffect(() => {
				const updateTimer = () => {
					const nextFlashSale = calculateNextFlashSale();
					const now = new Date();
					const timeDifference = nextFlashSale - now;
		
					if (timeDifference > 0) {
						const hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24);
						const minutes = Math.floor((timeDifference / (1000 * 60)) % 60);
						const seconds = Math.floor((timeDifference / 1000) % 60);
		
						setTimeLeft(`${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`);
					} else {
						setTimeLeft("00:00:00"); // Flash sale telah berakhir
					}
				};
		
				updateTimer(); // Hitung waktu tersisa saat pertama kali dimuat
				const intervalId = setInterval(updateTimer, 1000); // Perbarui setiap detik
		
				return () => clearInterval(intervalId); // Bersihkan interval saat komponen di-unmount
			}, []);
		
			return timeLeft;
		};
	
		const timeLefts = useFlashSaleTimer(); // Menggunakan hook timer

	if (arrows) {
		arrows = (
			<div className="block-header__arrows-list">
				<button className="block-header__arrow block-header__arrow--left" type="button" onClick={onPrev}>
					<ArrowRoundedLeft7x11Svg />
				</button>
				<button className="block-header__arrow block-header__arrow--right" type="button" onClick={onNext}>
					<ArrowRoundedRight7x11Svg />
				</button>
			</div>
		);
	}

	let groupsList;

	if (groups.length > 0) {
		groupsList = groups.map((group, index) => {
			const classes = classNames("block-header__group", {
				"block-header__group--active": group.current,
			});

			return (
				<li key={index}>
					<button type="button" className={classes} onClick={() => onGroupClick(group)}>
						{console.log(group.waktu)}
						
					</button>
				</li>
			);
		});

		groupsList = <ul className="block-header__groups-list">{groupsList}</ul>;
	}
     
    // console.log(waktu);
	return (
		<div className="block-header">
			<h3 className="block-header__title">{title}</h3> 
			<div className="block-header__divider" />
			{groupsList} <h4 className="block-header__title">{timeLefts}</h4>&nbsp;
			{arrows}
		</div>
	);
}

BlockHeaderFlashSale.propTypes = {
	title: PropTypes.string,
	arrows: PropTypes.bool,
	groups: PropTypes.array,
	onNext: PropTypes.func,
	onPrev: PropTypes.func,
	onGroupClick: PropTypes.func,
};
BlockHeaderFlashSale.defaultProps = {
	groups: [],
	onGroupClick: () => {},
};

export default BlockHeaderFlashSale;
